import React from 'react';
import { Spin, Tooltip } from 'antd';
import { computeTimeConstraint } from 'util/computeData';
import converPricingValue from 'util/convertPricingValue';
import { convertToSpamVolume } from 'util/computeDataCompWithSpam';

const renderData = (value, sample, dataFreq, spam) => {
  if (sample) {
    return <div>
      <div>{dataFreq ? converPricingValue(Math.round(computeTimeConstraint(value, dataFreq) * 1)) : converPricingValue(Math.round(value))}</div>
      {value > 0 ? <div className='gx-text-danger'><Tooltip title="Buzz của Spam chỉ áp dụng cho Cleaning">* Spam: {dataFreq ? converPricingValue(Math.round(computeTimeConstraint(convertToSpamVolume(value, spam), dataFreq) * 1)) : converPricingValue(Math.round(convertToSpamVolume(value, spam)))}</Tooltip></div> : null}
      <div className='gx-text-primary'><Tooltip title="Buzz của Sample chỉ áp dụng cho Sentiment và Attribute">* Sample: {converPricingValue(Math.round(sample))}</Tooltip></div>
    </div>
  }
  return (
    <div>
      <div className='gx-text-primary'>{dataFreq && value > 0 ? converPricingValue(Math.round(computeTimeConstraint(value, dataFreq) * 1)) : converPricingValue(Math.round(value))}</div>
      {value > 0 ? <div className='gx-text-danger'><Tooltip title="Buzz của Spam chỉ áp dụng cho Cleaning">* Spam: {dataFreq && value > 0 ? converPricingValue(Math.round(computeTimeConstraint(convertToSpamVolume(value, spam), dataFreq) * 1)) : converPricingValue(Math.round(convertToSpamVolume(value, spam)))}</Tooltip></div> : null}
    </div>
  );
};

const BuzzColumns = (sampleList, loadingSample, loadingSampleMulti, chosenBrand, dataFreq, spam) => {
  return [
    {
      title: 'Brand 1',
      dataIndex: 'brand',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 0) || loadingSampleMulti}>{renderData(next, sampleList[0], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 2',
      dataIndex: 'comp1',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample  && chosenBrand === 1) || loadingSampleMulti}>{renderData(next, sampleList[1], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 3',
      dataIndex: 'comp2',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample  && chosenBrand === 2) || loadingSampleMulti}>{renderData(next, sampleList[2], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 4',
      dataIndex: 'comp3',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample  && chosenBrand === 3) || loadingSampleMulti}>{renderData(next, sampleList[3], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 5',
      dataIndex: 'comp4',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 4) || loadingSampleMulti}>{renderData(next, sampleList[4], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 6',
      dataIndex: 'comp5',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 5) || loadingSampleMulti}>{renderData(next, sampleList[5], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 7',
      dataIndex: 'comp6',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 6) || loadingSampleMulti}>{renderData(next, sampleList[6], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 8',
      dataIndex: 'comp7',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 7) || loadingSampleMulti}>{renderData(next, sampleList[7], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 9',
      dataIndex: 'comp8',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 8) || loadingSampleMulti}>{renderData(next, sampleList[8], dataFreq, spam)}</Spin>,
    },
    {
      title: 'Brand 10',
      dataIndex: 'comp9',
      render: ({ next = 0 } = { next: 0, prev: 0 }) => <Spin spinning={(loadingSample && chosenBrand === 9) || loadingSampleMulti}>{renderData(next, sampleList[9], dataFreq, spam)}</Spin>,
    },
  ];
};

export default BuzzColumns;
